import React from "react";
import Moment from "react-moment";
import { Card, CardBody, Button } from "reactstrap";

const parseLocalDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;

  const s = dateStr.trim();

  const isoMatch = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, y, m, d] = isoMatch.map(Number);
    return new Date(y, m - 1, d);
  }

  const latamMatch = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (latamMatch) {
    const [, d, m, y] = latamMatch.map(Number);
    return new Date(y, m - 1, d);
  }

  const dt = new Date(s);
  return isNaN(dt) ? null : dt;
};

const isWithinNextDays = (dateStr, days) => {
  const d = parseLocalDate(dateStr);
  if (!(d instanceof Date) || isNaN(d)) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upper = new Date(today);
  upper.setDate(today.getDate() + days);

  return d >= today && d <= upper;
};

const ExpiringSoonFromHits = ({
                                hits = [],
                                currentUserEmail,
                                onFocus,
                                days = 7,
                                onlyMine = true,
                              }) => {
  const emailNorm = (currentUserEmail || "").trim().toLowerCase();
  if (onlyMine && !emailNorm) return null;

  const ownSoon = hits
    .map(h => h._source || h)
    .filter(h => {
      const pub = h?.minisite_publication;
      if (!pub?.desactivate_at) return false;

      if (onlyMine) {
        const recruiter = (pub.recruiter || "").trim().toLowerCase();
        if (!recruiter || recruiter !== emailNorm) return false;
      }

      return isWithinNextDays(pub.desactivate_at, days);
    })
    .sort((a, b) => {
      const da = parseLocalDate(a.minisite_publication.desactivate_at);
      const db = parseLocalDate(b.minisite_publication.desactivate_at);
      return da - db;
    })
    .slice(0, 10);

  if (!ownSoon.length) return null;

  return (
    <Card className="mb-3 material-shadow border-warning">
      <CardBody className="py-3">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h3 className="h6 mb-0">
            <i className="far fa-hourglass-half me-2" aria-hidden="true" />
            Próximas a expirar
          </h3>
          <small className="text-muted">
            {onlyMine ? "Tus procesos" : "Procesos"} (ordenados por fecha)
          </small>
        </div>

        <ul className="list-unstyled mb-0">
          {ownSoon.map(h => {
            const pub = h.minisite_publication;
            return (
              <li key={h.id} className="d-flex align-items-center justify-content-between py-1">
                <div className="me-2 text-truncate" style={{ maxWidth: "70%" }}>
                  <div className="fw-semibold text-truncate">{h.title}</div>
                  <div className="small">
                    Expira: <Moment format="DD/MM/YYYY">{pub.desactivate_at}</Moment>
                  </div>
                </div>
                <div className="ms-2">
                  <Button
                    size="sm"
                    color="link"
                    title="Ver en la lista"
                    onClick={() => onFocus?.(h.id)}
                  >
                    <i className="far fa-eye" aria-hidden="true" />
                  </Button>
                </div>
              </li>
            );
          })}
        </ul>
      </CardBody>
    </Card>
  );
};

export default ExpiringSoonFromHits;
